import ListItem from '@tiptap/extension-list-item';

export const ContentListItem = ListItem.extend({
  draggable: false,
});
